import { ContentArchetype } from './tome';

export type ReaderTheme = 'void_black' | 'terminal_cyan' | 'planck_amber' | 'core_crimson';
export type FontSizeSetting = 'small' | 'medium' | 'large' | 'xlarge';
export type FontSize = FontSizeSetting;
export type LineSpacingSetting = 'compact' | 'normal' | 'relaxed';
export type LineSpacing = LineSpacingSetting;
export type FontFaceSetting = 'serif' | 'mono' | 'sans';
export type FontFamily = FontFaceSetting;

export interface ReaderSettings {
  theme: ReaderTheme;
  fontSize: FontSizeSetting;
  lineSpacing: LineSpacingSetting;
  fontFamily: FontFaceSetting;
  fontFace?: FontFaceSetting;
  crtScanlines?: boolean;
  reducedMotion?: boolean;
  motionReduced?: boolean;
  masterVolume?: number;
  isMuted?: boolean;
}

export interface Bookmark {
  id: string;
  pageNumber: number;
  createdAt: number;
  title: string;
  previewSnippet?: string;
  textSnippet?: string;
  actTitle?: string;
  note?: string;
}

export interface BacklogEntry {
  id: string;
  pageNumber: number;
  title: string;
  chapterTitle: string;
  contentArchetype: ContentArchetype;
  textSnippet?: string;
  fullText?: string[];
  text?: string[];
  visitedAt: number;
}

export interface ReaderState {
  currentPage: number; // 1 to 500
  totalPages: number;  // 500
  isTocOpen: boolean;
  isBookmarksOpen: boolean;
  isBacklogOpen: boolean;
  isSettingsOpen: boolean;
  isAudioUnlocked: boolean;
  isMuted: boolean;
  volume: number;      // 0.0 to 1.0
  settings: ReaderSettings;
  bookmarks: Bookmark[];
  backlog: BacklogEntry[];
}

export type ReaderAction =
  | { type: 'GOTO_PAGE'; page: number }
  | { type: 'NEXT_PAGE' }
  | { type: 'PREV_PAGE' }
  | { type: 'STEP_PAGES'; step: number }
  | { type: 'TOGGLE_TOC'; open?: boolean }
  | { type: 'TOGGLE_BOOKMARKS'; open?: boolean }
  | { type: 'TOGGLE_BACKLOG'; open?: boolean }
  | { type: 'TOGGLE_SETTINGS'; open?: boolean }
  | { type: 'ADD_BOOKMARK'; bookmark: Bookmark }
  | { type: 'REMOVE_BOOKMARK'; id: string }
  | { type: 'UPDATE_SETTINGS'; settings: Partial<ReaderSettings> }
  | { type: 'SET_AUDIO_UNLOCKED'; unlocked: boolean }
  | { type: 'SET_MUTED'; muted: boolean }
  | { type: 'SET_VOLUME'; volume: number }
  | { type: 'CLEAR_BACKLOG' }
  | { type: 'RESET_DATA' };

export const DEFAULT_READER_SETTINGS: ReaderSettings = {
  theme: 'void_black',
  fontSize: 'medium',
  lineSpacing: 'normal',
  fontFamily: 'serif',
  fontFace: 'serif',
  crtScanlines: true,
  reducedMotion: false,
  motionReduced: false,
  masterVolume: 0.8,
  isMuted: false,
};
